module.exports = __webpack_public_path__ + "static/img/cxfw.2580e69.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cxfw.png
// module id = wDQz
// module chunks = 1